<template>
  <LazySection>
    <section class="feature-section reverse">
      <div class="content feature-content">
        <div class="feature-video">
          <div class="video-frame">
            <div class="video-frame__bar">
              <span class="video-frame__dot"></span>
              <span class="video-frame__dot"></span>
              <span class="video-frame__dot"></span>
              <span class="video-frame__address"></span>
            </div>
            <BaseVideo
              class="section-video"
              src="https://ju-financeiro-publi.s3.sa-east-1.amazonaws.com/videos/criando+nota.mp4"
            />
          </div>
        </div>
        <div class="feature-text">
          <h1 v-html="$t('message.nfseTitle')" class="title" />
          <p v-html="$t('message.nfseDescription')" />
        </div>
      </div>
    </section>
  </LazySection>
</template>

<script setup>
import BaseVideo from './BaseVideo.vue'
import LazySection from './Global/LazySection.vue'
</script>

<style scoped>
.feature-section {
  padding: 6rem 0;
  background-color: var(--c4);
}

.feature-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.feature-video {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
}

.video-frame {
  width: 100%;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  background: var(--c1);
}

.video-frame__bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: var(--c1);
}

.video-frame__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--c6);
}

.video-frame__address {
  flex: 1;
  height: 14px;
  margin-left: 10px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.12);
  max-width: 220px;
}

.section-video {
  max-width: 100%;
  height: auto;
  display: block;
}

.feature-text {
  flex: 1;
  text-align: center;
}

.feature-text p {
  font-size: clamp(1rem, 2.5vw, 1.3rem);
  line-height: 1.6;
  color: var(--c3);
  max-width: 800px;
  margin: 0 auto 2rem auto;
}

@media (min-width: 992px) {
  .feature-content {
    flex-direction: row; /* Image left, text right */
    text-align: left;
    gap: 64px;
  }

  .feature-section.reverse .feature-content {
    flex-direction: row-reverse; /* Image right, text left */
  }

  .feature-video {
    margin-bottom: 0;
    justify-content: flex-start;
  }

  .feature-text {
    text-align: left;
  }

  .feature-text p {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
